// extracted by mini-css-extract-plugin
export default {"header":"Header_header__xyGYP","header__text":"Header_header__text__SjUlG"};